// import React, { useState } from "react";

// export default function ProcessingCalculator() {
//   const [industry, setIndustry] = useState("rice");
//   const [beneficiary, setBeneficiary] = useState("proprietorship");
//   const [gender, setGender] = useState("male");
//   const [cost, setCost] = useState("");
//   const [result, setResult] = useState(null);

//   // 🔴 IMPORTANT: Replace this logic with your Excel values
//   const getRate = () => {
//     if (industry === "rice") {
//       if (beneficiary === "proprietorship") {
//         return gender === "female" ? 0.35 : 0.30;
//       }
//       if (beneficiary === "partnership") return 0.30;
//       if (beneficiary === "private") return 0.25;
//     }

//     if (industry === "cotton") {
//       return 0.30;
//     }

//     if (industry === "seed") {
//       return 0.35;
//     }

//     if (industry === "cashew") {
//       return 0.40;
//     }

//     if (industry === "other") {
//       return 0.25;
//     }
//   };

//   const getMax = () => {
//     if (beneficiary === "private") return 25000000;
//     if (beneficiary === "partnership") return 30000000;
//     return 20000000;
//   };

//   const calculate = () => {
//     const rate = getRate();
//     const calc = cost * rate;
//     const max = getMax();

//     setResult({
//       rate: rate * 100,
//       calc,
//       max,
//       final: Math.min(calc, max),
//     });
//   };

//     const handleReset = () => {
//   setIndustry("processing");
//   setBeneficiary("proprietorship");
//   setGender("male");
//   setCost("");
//   setResult(null);
// };

//   return (
//     <div className="card">
//       <h2>Processing Unit</h2>

//       {/* Industry Type */}
//       <label>Industry Type</label>
//       <select onChange={(e) => setIndustry(e.target.value)}>
//         <option value="rice">Rice Mill</option>
//         <option value="cotton">Cotton Ginning Mill</option>
//         <option value="seed">Seed Processing Unit</option>
//         <option value="cashew">Cashew Nut Processing Unit</option>
//         <option value="other">Other Processing Units</option>
//       </select>

//       {/* Beneficiary Type */}
//       <label>Beneficiary Type</label>
//       <select onChange={(e) => setBeneficiary(e.target.value)}>
//         <option value="proprietorship">Proprietorship</option>
//         <option value="partnership">Partnership</option>
//         <option value="private">Private Limited</option>
//       </select>

//       {/* Gender */}
//       <label>Gender</label>
//       <select onChange={(e) => setGender(e.target.value)}>
//         <option value="male">Male</option>
//         <option value="female">Female</option>
//       </select>

//       <small style={{ color: "#666" }}>
//         (In case one partner is male, please select male)
//       </small>

//       {/* Project Cost */}
//       <label>Project Cost (₹)</label>
//       <input
//         type="number"
//         value={cost}
//         onChange={(e) => setCost(e.target.value)}
//       />

//     <div className="btn-group">
//   <button onClick={calculate}>Calculate Subsidy</button>
//   <button className="reset-btn" onClick={handleReset}>
//     Reset
//   </button>
// </div>
//       {/* Result */}
//       {result && (
//         <div className="result">
//           <p>Subsidy Rate: {result.rate}%</p>
//           <p>Calculated Amount: ₹{result.calc.toLocaleString()}</p>
//           <p>Maximum Eligible: ₹{result.max.toLocaleString()}</p>
//           <h3>Final Subsidy: ₹{result.final.toLocaleString()}</h3>
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useState } from "react";

export default function ProcessingCalculator() {
  const [industry, setIndustry] = useState("");
  const [beneficiary, setBeneficiary] = useState("");
  const [gender, setGender] = useState("");
  const [cost, setCost] = useState("");
  const [result, setResult] = useState(null);

  // ✅ SAME as warehouse
  // const getRate = () => {
  //   return gender === "female" ? 0.3333 : 0.25;
  // };
  const getRate = () => {
  if (gender === "female" || gender === "scst") {
    return 0.3333;
  }
  return 0.25;
};

  // const getMax = () => {
  //   return gender === "female" ? 3000000 : 2500000;
  // };

  const getMax = () => {
  if (gender === "female" || gender === "scst") {
    return 3000000; // ₹30 Lakhs
  }
  return 2500000; // ₹25 Lakhs
};

  const calculate = () => {
    const numericCost = Number(cost);

    if (!industry || !beneficiary || !gender) {
      alert("Please select all dropdowns");
      return;
    }

    if (!numericCost || numericCost <= 0) {
      alert("Enter valid project cost");
      return;
    }

    const rate = getRate();
    const calc = numericCost * rate;
    const max = getMax();

    setResult({
      rate: rate * 100,
      calc,
      max,
      final: Math.min(calc, max),
    });
  };

  const handleReset = () => {
    setIndustry("");
    setBeneficiary("");
    setGender("");
    setCost("");
    setResult(null);
  };

  return (
    <div className="card-calculator">
      <h2>Processing Unit</h2>

      {/* Industry */}
      <label>Industry Type</label>
      <select value={industry} onChange={(e) => setIndustry(e.target.value)}>
        <option value="">Select Industry</option>
        <option value="rice">Rice Mill</option>
        <option value="cotton">Cotton Ginning Mill</option>
        <option value="seed">Seed Processing Unit</option>
        <option value="cashew">Cashew Nut Processing Unit</option>
        <option value="other">Other Processing Units</option>
      </select>

      {/* Beneficiary */}
      <label>Beneficiary Type</label>
      <select value={beneficiary} onChange={(e) => setBeneficiary(e.target.value)}>
        <option value="">Select Beneficiary</option>
        <option value="proprietorship">Proprietorship</option>
        <option value="partnership">Partnership</option>
        <option value="private">Private Limited</option>
      </select>

      <small>(Not used in calculation)</small>

      {/* Gender */}
      <label>Gender</label>
      <select value={gender} onChange={(e) => setGender(e.target.value)}>
        <option value="">Select Gender</option>
        <option value="male">Male</option>
        <option value="female">Female</option>
         <option value="scst">SC / ST</option>
      </select>
      (In case one partner is male, please select male)


      {/* Cost */}
      <label>Project Cost (₹)</label>
      <input
        type="number"
        value={cost}
        onChange={(e) => setCost(e.target.value)}
        placeholder="Enter amount"
      />

      {/* Buttons */}
      <div className="btn-group">
        <button
          onClick={calculate}
          disabled={!cost || !industry || !beneficiary || !gender}
        >
          Calculate Subsidy
        </button>
        <button className="reset-btn" onClick={handleReset}>
          Reset
        </button>
      </div>

      {/* Result */}
      {result && (
        <div className="result">
         <p>
  Applied Rule:{" "}
  {gender === "female"
    ? "33.33% (Women / SC-ST) - Max ₹30 Lakhs"
    : "25% (General) - Max ₹25 Lakhs"}
</p>
          <p>Subsidy Rate: {result.rate.toFixed(2)}%</p>
          <p>Calculated Amount: ₹{result.calc.toLocaleString()}</p>
          <p>Maximum Eligible: ₹{result.max.toLocaleString()}</p>
          <h3>Final Subsidy: ₹{result.final.toLocaleString()}</h3>
        </div>
      )}
    </div>
  );
}